<template>
    <div class="e3-action-btn-outer">
        <div v-if="subBtnsVisible" class="backdrop"/>
        <div v-click-outside="close" class="e3-action-btn-container" :class="{'z-index' : subBtnsVisible}">
            <transition
                name="fade"
                mode="out-in">
                <div v-if="hasSubButtons() && subBtnsVisible" class="e3-action-sub-container" @click="toggleSubBtns">
                    <slot name="subButtons"/>
                </div>
            </transition>
            <button type="button" class="e3-action-btn" :title="title" @click="handleButtonAction">
                <PlusThickIcon size="36" class="text-white e3-transition" :class="{'e3-rotate-45' : subBtnsVisible}"/>
            </button>
        </div>
    </div>
</template>

<script>
import PlusThickIcon from '@/common/components/svg-icons/PlusThickIcon.vue';

export default {
    props: {
        title: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            subBtnsVisible: false
        };
    },
    methods: {
        // TODO: Vue 3 move to computed prop — $slots is reactive there
        hasSubButtons() {
            return !!this.$slots.subButtons;
        },
        handleButtonAction() {
            if (this.hasSubButtons()) {
                this.toggleSubBtns();
            } else {
                this.add();
            }
        },
        add() {
            this.$emit('addNewClicked');
        },
        toggleSubBtns() {
            this.subBtnsVisible = !this.subBtnsVisible;
        },
        close() {
            if (this.hasSubButtons() && this.subBtnsVisible) {
                this.subBtnsVisible = false;
            }
        }
    },
    components: {
        PlusThickIcon
    },
    created() {
        this.$store.commit('SET_ACTION_BUTTON_ACTIVE', true);
    },
    destroyed() {
        this.$store.commit('SET_ACTION_BUTTON_ACTIVE', false);
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.e3-action-btn-outer {
    display: inline-flex;
    width: 62px;
}

@media screen and (max-width: $grid-br-md) {
    .backdrop {
        background-color: $light-gray;
        opacity: 40%;
        position: absolute;
        bottom: -16px;
        right: -16px;
        z-index: 10000;
        width: 100vw;
        height: 100vh;
    }
}

div:not(.fixed-buttons) > .e3-action-btn-container {
    position: fixed;
    right: 16px;
    bottom: 16px;
    &.z-index {
        z-index: 10001;
    }
}

.e3-action-sub-container {
    position: absolute;
    bottom: 62px;
    right: 0;
}

.e3-action-btn {
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 62px;
    background-color: $primary;
    border: none;
    border-radius: 50%;
    transition: box-shadow .2s ease-in;
    animation: pulse 2s 5;

    &:hover, &:focus {
        outline: none;
        animation: none;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

@-webkit-keyframes pulse {
    0% {
        -webkit-box-shadow: 0 0 0 0 rgba($primary, 0.4);
    }
    70% {
        -webkit-box-shadow: 0 0 0 10px rgba($primary, 0);
    }
    100% {
        -webkit-box-shadow: 0 0 0 0 rgba($primary, 0);
    }
}

@keyframes pulse {
    0% {
        -moz-box-shadow: 0 0 0 0 rgba($primary, 0.4);
        box-shadow: 0 0 0 0 rgba($primary, 0.4);
    }
    70% {
        -moz-box-shadow: 0 0 0 10px rgba($primary, 0);
        box-shadow: 0 0 0 10px rgba($primary, 0);
    }
    100% {
        -moz-box-shadow: 0 0 0 0 rgba($primary, 0);
        box-shadow: 0 0 0 0 rgba($primary, 0);
    }
}
</style>
